var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ScipherLayout',[(_vm.cohort)?_c('ThoughtSpotHeader',{attrs:{"cohort":_vm.cohort}}):_vm._e(),_c('div',{attrs:{"id":"ts-embed"}}),(_vm.isLoading)?_c('Loader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }